import React from "react";
import { Header, Paragraph, useTheme } from "@tvg/design-system";
import { useColorTokens } from "@tvg/design-system/web/hooks";
import type { Props } from "./types";
import { useBetsInfo } from "./hooks";
import { InfoContainer, CounterContainer, Wrapper } from "./styled-components";

const MyBetsModalHeader = ({ title }: Props) => {
  const { space } = useTheme();
  const userBetInfo = useBetsInfo();
  const colorTokens = useColorTokens();

  return (
    <Wrapper>
      <Header
        tag="h1"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
      >
        {title}
      </Header>
      {userBetInfo.length ? (
        <CounterContainer>
          {userBetInfo.map((info) => (
            <InfoContainer space={space}>
              <Paragraph qaLabel={info.qaLabel} pr="space-1" fontFamily="bold">
                {info.label}
              </Paragraph>
              <Paragraph
                qaLabel={`${info.qaLabel}-description`}
                fontSize="xs"
                textTransform="uppercase"
                color={colorTokens.content.subtle}
              >
                {info.description}
              </Paragraph>
            </InfoContainer>
          ))}
        </CounterContainer>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};

export default MyBetsModalHeader;
